import { WidgetBarChartWithSlider } from '../Widgets';
import { connect } from 'react-redux';
import { getConversionData } from '../../redux/actions/conversion';
import { getTimingData } from '../../redux/actions/timings';
import { sumByField, formatDate, formatDateFromRange } from '../../helpers';

const mapStateToProps = (state, ownProps) => ({
  id: 'WidgetDetailedVisits',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.conversion.WidgetDetailedVisits && state.conversion.WidgetDetailedVisits.data && state.filter.filters.startDate && state.filter.filters.endDate ? state.conversion.WidgetDetailedVisits.data.map(item => ({
    value: item.nv,
    key: formatDateFromRange(item.dt, state.filter.filters),
    date: item.dt
  })) : [],
  conversionData: state.conversion.WidgetDetailedVisits ? state.conversion.WidgetDetailedVisits.data : [],
  extraGraphData: state.conversion.WidgetDetailedVisitsExtra && state.conversion.WidgetDetailedVisitsExtra.data && state.filter.filters.startDate && state.filter.filters.endDate ?  [
    {
      value: sumByField(state.conversion.WidgetDetailedVisitsExtra.data, 'nv'),
      key: "Number of Visits"
    }, {
      value: sumByField(state.conversion.WidgetDetailedVisitsExtra.data, 'nsbm') * 10,
      key: "Number of Submissions"
    }, {
      value: sumByField(state.conversion.WidgetDetailedVisitsExtra.data, 'ns') * 10,
      key: "Number of Subscribers"
    }
  ] : [],
  extraGraphTooltipData: state.conversion.WidgetDetailedVisitsExtra && state.conversion.WidgetDetailedVisitsExtra.data && state.filter.filters.startDate && state.filter.filters.endDate ?  [
    {
      value: sumByField(state.conversion.WidgetDetailedVisitsExtra.data, 'nv'),
      key: "Number of Visits"
    }, {
      value: sumByField(state.conversion.WidgetDetailedVisitsExtra.data, 'nsbm'),
      key: "Number of Submissions"
    }, {
      value: sumByField(state.conversion.WidgetDetailedVisitsExtra.data, 'ns'),
      key: "Number of Subscribers"
    }
  ] : [],
  legendData: state.timings.WidgetDetailedVisitsLegend0 && state.timings.WidgetDetailedVisitsLegend0.data && state.timings.WidgetDetailedVisitsLegend1 && state.timings.WidgetDetailedVisitsLegend1.data ? [
    {
      amount: `${(sumByField(state.timings.WidgetDetailedVisitsLegend0.data, 'value') / state.timings.WidgetDetailedVisitsLegend0.data.length).toFixed(2)}ms`,
      description: "Avg Session Time"
    }, {
      amount: `${(sumByField(state.timings.WidgetDetailedVisitsLegend1.data, 'value') / state.timings.WidgetDetailedVisitsLegend1.data.length).toFixed(2)}ms`,
      description: "Avg Page Load Time"
    }
  ] : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.conversion.WidgetDetailedVisits
    && state.conversion.WidgetDetailedVisits.loaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  loaded: state.conversion.WidgetDetailedVisits
    && state.conversion.WidgetDetailedVisits.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  shouldLoadData: !state.conversion.WidgetDetailedVisits || (!state.conversion.WidgetDetailedVisits.loaded && !state.conversion.WidgetDetailedVisits.loading && !state.conversion.WidgetDetailedVisits.error),
  customFilter: true,
  customFilterAcceptedParams: ['pageId', 'os', 'campaignId', 'flowId', 'partnerId']
})

const mapDispatchToProps = { fetchData: getConversionData, fetchLegendData: getTimingData };

export default connect(mapStateToProps, mapDispatchToProps)(WidgetBarChartWithSlider)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetDetailedVisitsConnected.js